import React, { useState, useEffect } from 'react';
import { Navbar, Nav, Container, Modal, Image } from 'react-bootstrap';
import Countdown from 'react-countdown';
import useSidebar from '../../hooks/useSidebar';
import NavbarNotification from './NavbarNotification';
import NavbarUser from './NavbarUser';
import { useDispatch, useSelector } from 'react-redux';
import { fetchStartCurrent } from '../../redux/slices/DisputeCenterSlice';
import { navItem } from './navbaritems';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { fetchPackagesDetail, fetchCurrentPlan } from '../../redux/slices/EnhanceDisputeSlice';
import { blankGetAllReportData, getAllReport, createDisputeLetter } from '../../redux/slices/ReportSlice';
import Logo from './disputely-logo-blue.svg';
import GoldStar from '../../pages/dispute_center/partials/star.svg';

import PromoModal from './PromoModal';
import EnhanceCurrentDisputes from '../../pages/enhance_dispute/EnhanceCurrentDisputes';
import moment from 'moment';

const NavbarComponent = ({ showNav }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const state = useState();
  let location = useLocation();
  const getAllReportData = useSelector(state => state.reports.getAllReportData);
  const reportStatus = useSelector(state => state.reports.getAllReportStatus);
  const countdownRenderer = ({ days, hours, minutes, seconds, completed }) => {
    if (completed || days <= 0) {
      // Render any custom completion message
      return <span className=''>Last chance to upgrade!</span>;
    } else {
      // Render the countdown with the remaining days
      return <span className=''>{days} days remaining</span>;
    }
  };

  // Add small nav items
  const smallNavItems = [
    { href: '', name: '5 days left to go Enhanced for this cycle' },
    { href: '/small-link-2', name: 'Countdown' },
  ];

  useEffect(() => {
    if (reportStatus === 'idle') dispatch(getAllReport({
            clientId: 1,
            roundid: 1,
          }));
  }, [reportStatus]);

  const startDate = moment(getAllReportData?.data?.round_start_date || new Date())
    .add(5, 'days');
    
  const targetDate = new Date(startDate);
  // //console.log(reportStatus)
  return (
    <>
      {/* Add small navigation menu */}
      {showNav && getAllReportData?.data?.clientInfo.current_plan === '1' && getAllReportData?.data?.round_start_date && startDate.diff(moment(), 'seconds') > 0 && (
        <Nav id='promoNav' className='mx-auto bg-primary w-100 justify-content-center'>
          <Nav.Link className='nav-link text-white'>
            <span className='position-relative'>
              <Image className='position-absolute' style={{ right: '5px' }} src={GoldStar} />
            </span>{' '}
            <Countdown date={targetDate} renderer={countdownRenderer} /> to go ENHANCED!
          </Nav.Link>
          <Nav.Link className='nav-link text-white px-0' onClick={() => setShowUpgradeModal(true)}>
            <span className='px-2 text-decoration-underline text-white'>LEARN MORE</span>
          </Nav.Link>
          <Nav.Link>
            <span className='fw-bold text-white'>
              <Countdown date={targetDate} />
            </span>
          </Nav.Link>
        </Nav>
      )}

      <Modal centered size='md' show={showUpgradeModal} onHide={() => setShowUpgradeModal(false)}>
        <Modal.Header closeButton>&nbsp;</Modal.Header>
        <Modal.Body>
          <EnhanceCurrentDisputes disputelyMailed={true} onPlanClick={() => setShowUpgradeModal(false)} />
        </Modal.Body>
      </Modal>

      <Navbar collapseOnSelect expand='lg' className='navbar-light navbar-sticky header-static'>
        <style>
          {`
        #navbar .active {
          color: var(--bs-primary) !important;
        }
        `}
        </style>
        <Container fluid className='px-5 px-xl-0 container-fluid-1335'>
          <Navbar.Brand>
            <Link className='text-dark-blue font-weight-bold text-decoration-none fs-3' to={showNav ? '/dashboard' : ''}>
              <img src={Logo} alt='premium stars' fill='var(--bs-primary)' className='text-primary' width='120' height='auto' />
            </Link>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls='basic-navbar-nav' className='collapsed' data-toggle='navbar-collapse w-100 collapse' data-target='#navbar' aria-expanded='false' />
          <Navbar.Collapse id='navbar' className='navbar-nav navbar-nav-scroll mx-auto navbar-collapse collapse w-100'>
            <Nav className='mx-auto'>
              {showNav &&
                navItem.map((data, index) => {
                  //check is active
                  let isActive = false;
                  if (data.href === location.pathname) {
                    isActive = true;
                  }
                  return (
                    <Link key={index} to={data.href} className={`d-flex nav-link text-dark-blue font-weight-bold mb-0 justify-content-center ${isActive ? 'active' : ''}`}>
                      {data.name}
                    </Link>
                  );
                })}
            </Nav>

            <Nav className='navbar-align align-self-end d-flex m-0 justify-content-end align-items-center'>
              {showNav && <NavbarNotification />}
              <NavbarUser showNav={showNav} />
            </Nav>
          </Navbar.Collapse>
        </Container>
        {showNav && <PromoModal />}
      </Navbar>
    </>
  );
};

export default NavbarComponent;
